import React, { Dispatch } from 'react';
import { Common } from '../../core/common';
import { connect } from 'react-redux';
import { IAppState, IAction, IAuthInformation } from '../../models/action/core';
import { withRouter } from 'react-router-dom';
import { UserType } from '../../models/enums/userType';
import axios from 'axios';
import { LoginPageService } from '../../api/login-page-service';
import { resultLoginForm } from '../../store/actions/login';

let _common: Common;
const loginPageService = new LoginPageService();
class OidcLogin extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    _common = new Common();
  }

  componentDidMount() {
    const whoamiUrl = `${window.location.origin}/oidc/whoami`;

    axios.get(whoamiUrl, { withCredentials: true })
      .then(async (response) => {

        const data = response.data;
        const { access_token, refresh_token, expires_in } = data;

        if (access_token) {
          const expire_date = new Date();
          expire_date.setSeconds(expire_date.getSeconds() + (expires_in ?? 0));

          const authInfo: IAuthInformation = {
            access_token,
            refresh_token: refresh_token ?? '',
            expire_date,
            auth_url: window.appSettings?.AUTH_URL ?? ''
          };

          _common.InsertAuthLocalStorage(authInfo);

          const identityData = await this.requestIdentity();

          if (identityData) {

            this.props.dispatch(resultLoginForm({
              isLogin: true,
              isError: false,
              errorMessage: "",
              customLoginPermission: identityData.customLoginPermission,
              email: identityData.email,
              loginPermission: identityData.loginPermission,
              userName: identityData.userName,
              userType: identityData.userType,
              fullName: identityData.fullName,
              firstName: identityData.firstName,
              lastName: identityData.lastName,
              userId: identityData.userId,
              profileImagePath: identityData.profileImagePath,
              isSimulate: identityData.isSimulate,
              culture: identityData.culture,
              clusterType: identityData.clusterType,
              organizationId: identityData.organizationId,
              timeZone: identityData.timeZone,
              forceChangePassword: identityData.forceChangePassword,
              programName: identityData.programName
            }, "whoAmI", 'set'));

            if (this.props.userType === UserType.Admin) {
              this.props.history.push('/almsp/u/Home/Cockpit');
            } else if (this.props.userType) {
              this.props.history.push('/almsp/u/Home/Index');
            } else {
              this.props.history.push('/almsp');
            }
          } else {
            this.props.history.push('/almsp');
          }

        } else {
          this.props.history.push('/almsp');
        }
      })
      .catch((err: any) => {
        this.props.history.push('/almsp');
      });
  }


  requestIdentity = async (): Promise<any | null> => {
    try {
      const response = await loginPageService.GetUserIdentity(false);
      if (response && response.status === 200) {
        return await response.json();
      } else {
        return null;
      }
    } catch (err: any) {
      if (err?.error) {
        console.log('requestIdentity -> exception', err.error);
      } else {
        console.log('requestIdentity -> exception', err);
      }
      return null;
    }
  };


  render() {
    return <div />;
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => {
  if (!state) return ownProps;
  return {
    ...ownProps,
    userType: state.login.identitiy.userType,
    identity: state.login.identitiy
  };
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({ dispatch });

const COidcLogin = connect(mapStateToProps, dispatchProps)(OidcLogin);
export default withRouter(COidcLogin);
